/* ==========================================================================
   NAUGHTY CITEES - SHEET INTERACTIVITY

   1. Live coordinate ticks. The latitude values on the page border update
      as you scroll, so you are physically travelling down a quadrangle.
   2. Plate thumbnails swap the main plate with no navigation.
   3. Garment specification form drives Shopify variant selection, and
      swaps Plate I to the photograph of the selected stock.
   ========================================================================== */

(function () {
  'use strict';

  /* ---- 1. LIVE COORDINATE TICKS ---------------------------------------- */

  function initLiveTicks() {
    var frame = document.querySelector('[data-nc-frame]');
    if (!frame) return;

    var lat = parseFloat(frame.getAttribute('data-nc-lat'));
    var lon = parseFloat(frame.getAttribute('data-nc-lon'));
    if (isNaN(lat) || isNaN(lon)) return;

    var leftTicks = frame.querySelectorAll('[data-nc-tick-lat]');
    var topTicks = frame.querySelectorAll('[data-nc-tick-lon]');
    if (!leftTicks.length) return;

    // A quadrangle is 7.5 minutes, i.e. 0.125 degrees. Scrolling the full
    // page traverses one quadrangle of latitude, travelling south.
    var SPAN = 0.125;
    var ticking = false;

    function fmt(v, pos, neg) {
      var hemi = v >= 0 ? pos : neg;
      var a = Math.abs(v);
      var d = Math.floor(a);
      var m = Math.floor((a - d) * 60);
      return d + '\u00B0' + (m < 10 ? '0' + m : m) + "' " + hemi;
    }

    function update() {
      ticking = false;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var progress = max > 0 ? window.scrollY / max : 0;
      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;

      var top = lat + SPAN / 2 - progress * SPAN;

      for (var i = 0; i < leftTicks.length; i++) {
        var frac = leftTicks.length > 1 ? i / (leftTicks.length - 1) : 0;
        leftTicks[i].textContent = fmt(top - frac * SPAN, 'N', 'S');
      }

      for (var j = 0; j < topTicks.length; j++) {
        var f = topTicks.length > 1 ? j / (topTicks.length - 1) : 0;
        topTicks[j].textContent = fmt(lon - SPAN / 2 + f * SPAN, 'E', 'W');
      }
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  /* ---- 2. PLATES -------------------------------------------------------- */

  var plateState = { active: 'garment' };

  function motionEl() {
    return document.querySelector('[data-nc-plate-motion]');
  }

  function showMotion(show) {
    var el = motionEl();
    if (!el) return;
    var video = el.querySelector('video');

    if (show) {
      el.hidden = false;
      if (video) {
        // preload is 'none' so the file is not fetched until asked for.
        video.muted = true;
        var p = video.play();
        if (p && p.catch) p.catch(function () { /* autoplay refused */ });
      }
    } else {
      el.hidden = true;
      if (video && !video.paused) video.pause();
    }
  }

  function setMainPlate(src, alt, caption) {
    var group = document.querySelector('[data-nc-plates]');
    if (!group) return;
    var main = group.querySelector('[data-nc-plate-main]');
    var label = group.querySelector('[data-nc-plate-label]');
    if (!main) return;

    main.hidden = false;

    if (src) {
      var img = main.querySelector('img');
      if (!img) {
        main.innerHTML = '';
        img = document.createElement('img');
        main.appendChild(img);
      }
      img.src = src;
      img.alt = alt || '';
    } else {
      main.innerHTML = '<p class="nc-plate__empty">Plate not yet issued</p>';
    }
    if (label && caption) label.innerHTML = caption;
  }

  function initPlates() {
    var group = document.querySelector('[data-nc-plates]');
    if (!group) return;

    var thumbs = group.querySelectorAll('[data-nc-thumb]');
    if (!thumbs.length) return;

    var main = group.querySelector('[data-nc-plate-main]');
    var label = group.querySelector('[data-nc-plate-label]');

    Array.prototype.forEach.call(thumbs, function (thumb) {
      thumb.addEventListener('click', function () {
        var kind = thumb.getAttribute('data-nc-plate') || 'garment';
        plateState.active = kind;

        Array.prototype.forEach.call(thumbs, function (t) {
          t.setAttribute('aria-selected', t === thumb ? 'true' : 'false');
        });

        if (kind === 'motion') {
          if (main) main.hidden = true;
          showMotion(true);
          if (label) label.innerHTML = thumb.getAttribute('data-nc-caption') || '';
          return;
        }

        showMotion(false);
        setMainPlate(
          thumb.getAttribute('data-nc-src'),
          thumb.getAttribute('data-nc-alt'),
          thumb.getAttribute('data-nc-caption')
        );
      });
    });
  }

  /* ---- 3. GARMENT SPECIFICATION ---------------------------------------- */

  function initSpec() {
    var spec = document.querySelector('[data-nc-spec]');
    if (!spec) return;

    var form = spec.querySelector('form');
    var idInput = spec.querySelector('[data-nc-variant-id]');
    var priceEl = spec.querySelector('[data-nc-price]');
    var submit = spec.querySelector('[data-nc-submit]');
    if (!form || !idInput) return;

    var variants = [];
    try { variants = JSON.parse(spec.getAttribute('data-nc-variants') || '[]'); }
    catch (e) { variants = []; }

    var selected = {};

    function currentVariant() {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var key in selected) {
          if (String(v.options[key]) !== String(selected[key])) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function syncGarmentThumb(v) {
      var thumb = document.querySelector('[data-nc-thumb][data-nc-plate="garment"]');
      if (!thumb || !v || !v.image) return;

      thumb.setAttribute('data-nc-src', v.image);
      var holder = thumb.querySelector('[data-nc-thumb-img]');
      if (holder && v.thumb) {
        var timg = holder.querySelector('img');
        if (!timg) {
          holder.innerHTML = '';
          timg = document.createElement('img');
          timg.alt = '';
          holder.appendChild(timg);
        }
        timg.src = v.thumb;
      }

      if (plateState.active === 'garment') {
        setMainPlate(v.image, thumb.getAttribute('data-nc-alt'), 'Plate I &mdash; Garment as issued');
      }
    }

    function refresh() {
      var v = currentVariant();

      if (v) {
        idInput.value = v.id;
        if (priceEl && v.price_formatted) priceEl.textContent = v.price_formatted;
        if (submit) {
          submit.disabled = !v.available;
          submit.textContent = v.available ? 'Submit Order' : 'Not in stock';
        }
        syncGarmentThumb(v);
      } else if (submit) {
        submit.disabled = true;
        submit.textContent = 'Not in stock';
      }

      var opts = spec.querySelectorAll('[data-nc-opt]');
      Array.prototype.forEach.call(opts, function (opt) {
        var pos = opt.getAttribute('data-nc-pos');
        var val = opt.getAttribute('data-nc-value');
        var probe = {};
        for (var k in selected) probe[k] = selected[k];
        probe[pos] = val;

        var possible = variants.some(function (variant) {
          for (var key in probe) {
            if (String(variant.options[key]) !== String(probe[key])) return false;
          }
          return variant.available;
        });

        opt.classList.toggle('nc-opt--unavailable', !possible);
      });
    }

    var groups = spec.querySelectorAll('[data-nc-optgroup]');
    Array.prototype.forEach.call(groups, function (group) {
      var pos = group.getAttribute('data-nc-optgroup');
      var opts = group.querySelectorAll('[data-nc-opt]');

      var seeded = false;
      Array.prototype.forEach.call(opts, function (opt) {
        if (!seeded && opt.getAttribute('aria-checked') === 'true') {
          selected[pos] = opt.getAttribute('data-nc-value');
          seeded = true;
        }
      });
      if (!seeded && opts.length) {
        selected[pos] = opts[0].getAttribute('data-nc-value');
        opts[0].setAttribute('aria-checked', 'true');
      }

      Array.prototype.forEach.call(opts, function (opt) {
        opt.addEventListener('click', function () {
          if (opt.classList.contains('nc-opt--unavailable')) return;
          selected[pos] = opt.getAttribute('data-nc-value');
          Array.prototype.forEach.call(opts, function (o) {
            o.setAttribute('aria-checked', o === opt ? 'true' : 'false');
          });
          refresh();
        });
      });
    });

    refresh();
  }

  function init() {
    initLiveTicks();
    initPlates();
    initSpec();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
